export default {
  'get-list': {
    method: 'post',
    url: ''
  },
  add: {
    method: 'post',
    url: ''
  },
  delete: {
    method: 'delete',
    url: ''
  },
  update: {
    method: 'PUT',
    url: '/driver/document/file/ID'
  },
  changeStatus: {
    method: 'put',
    url: ''
  },
  archive: {
    method: 'DELETE',
    url: '/driver/document/archive'
  },
  restore: {
    method: 'PUT',
    url: '/driver/document/restore'
  }
}
